import { render, staticRenderFns } from "./BatchSetPaRevenue.vue?vue&type=template&id=36826032&scoped=true"
import script from "./BatchSetPaRevenue.vue?vue&type=script&lang=js"
export * from "./BatchSetPaRevenue.vue?vue&type=script&lang=js"
import style0 from "./BatchSetPaRevenue.vue?vue&type=style&index=0&id=36826032&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36826032",
  null
  
)

export default component.exports